import React from "react";

import BranchDashboard from "../Claim/Claim";

export default function EntryCondition() {
  return <BranchDashboard />;
}
